<script setup lang="ts">
withDefaults(defineProps<{ value?: string }>(), { value: "" });

const { sanitizeHtml } = useSanitize();
</script>

<template>
  <div
    :class="[
      'content-text',
      'px-5 lg:px-0',
      'prose',
      'first:prose-p:-mt-2 prose-p:mb-5 last:prose-p:mb-0 prose-p:text-base prose-p:leading-8 prose-p:tracking-normal prose-p:text-[#242020]',
      'prose-headings:mb-5 last:prose-headings:mb-0 prose-headings:text-black',
      'prose-a:underline prose-a:text-inherit',
      'prose-ul:text-black',
      'prose-ol:text-black',
      'prose-li:text-black prose-li:m-0 prose-li:marker:text-black',
    ]"
    v-html="value ? sanitizeHtml(value) : undefined"
  ></div>
</template>
